module.exports = __webpack_public_path__ + "static/media/idp-pending-identification.997294e4.svg";